export const PADS = 'PADS';
export const KEYBOARD = 'KEYBOARD';
export const CONTROLCHANGE_PLAY = 118;
export const CONTROLCHANGE_RECORD = 119;
export const CONTROLCHANGE_STOP = 117;
export const CONTROLCHANGE_NEXT = 116;
export const CONTROLCHANGE_PREVIOUS = 115;
export const CONTROLCHANGE_SUSTAIN = 64;
export const CONTROLCHANGE_MODULATION = 1;
